import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiCheckCircle, FiAlertCircle } = FiIcons;

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [backendStatus, setBackendStatus] = useState('checking'); // 'checking', 'live', 'mock'

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Global Health Check - Purely for indicator status
  useEffect(() => {
    const checkConnectivity = async () => {
      try {
        const response = await fetch('/.netlify/functions/gateway', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'pb_health_check' })
        });
        
        if (!response.ok) throw new Error('Gateway Offline');
        
        const result = await response.json();
        if (result.success && result.data?.authenticated) {
          setBackendStatus('live');
        } else {
          setBackendStatus('mock');
        }
      } catch (err) {
        console.warn('Global health check failed:', err.message);
        setBackendStatus('mock');
      }
    };

    checkConnectivity();
  }, []);

  // Global Toast Listener
  useEffect(() => {
    const handleToast = (e) => {
      const id = Date.now() + Math.random();
      setToasts(prev => [...prev, { id, ...e.detail }]);
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 3500);
    };
    window.addEventListener('show-toast', handleToast);
    return () => window.removeEventListener('show-toast', handleToast);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 font-sans">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar toggleSidebar={toggleSidebar} backendStatus={backendStatus} />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 custom-scrollbar">
          <div className="max-w-7xl mx-auto pb-12">
            <Outlet context={{ backendStatus }} />
          </div>
        </main>
      </div>

      {/* Global Toast Container */}
      <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-[200] flex flex-col gap-3 pointer-events-none">
        {toasts.map(t => (
          <div key={t.id} className="bg-slate-900 border border-slate-700 text-white px-5 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-right-8 fade-in pointer-events-auto">
            <SafeIcon icon={t.type === 'error' ? FiAlertCircle : FiCheckCircle} className={`text-xl ${t.type === 'error' ? 'text-red-400' : 'text-emerald-400'}`} />
            <p className="text-sm font-bold tracking-wide">{t.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Layout;